import {
  useV2GetProjectByIdQuery,
  useV2ListProjectLocationsQuery,
} from "@generated";
import { projectRateTableId } from "../../../Projects/ServicesV2/api";
import { Project } from "../../types";

const useGetProjectById = (
  id: string,
  options?: { refetchOnMountOrArgChange?: boolean }
) => {
  let customError: string | null = null; // Declare customError

  const { data, isLoading, isFetching, error } = useV2GetProjectByIdQuery(
    {
      id,
      include: ["rate-table"],
    },
    options
  );

  // Every active location on the project, whether or not a service uses it:
  // the editor shows its Location column when there is more than one. Listed
  // directly because the project's project-locations linkage can come back
  // empty even when the locations are included.
  const {
    data: locationsData,
    isLoading: locationsLoading,
    isFetching: locationsFetching,
    error: locationsError,
  } = useV2ListProjectLocationsQuery(
    {
      filter: { project: id, active: true },
      page: { size: 1000 },
    },
    options
  );

  let project: Project | undefined = undefined;

  if (data?.data) {
    try {
      const p = data.data;
      const locations = (locationsData?.data || [])
        .map((location) => ({
          label: String(location.attributes?.name || ""),
          value: String(location.id || ""),
        }))
        .filter((l) => l.value);
      if (p?.id && p?.relationships) {
        project = {
          id: p.id,
          status: p?.attributes?.status,
          locations,
          rateTableId: projectRateTableId(data),
          executiveSummary: p?.attributes?.["executive-summary"],
          solutionSummary: p?.attributes?.["solution-summary"],
          ourResponsibilities: p?.attributes?.["our-responsibilities"],
          customerResponsibilities: p?.attributes?.["client-responsibilities"],
          outOfScope: p?.attributes?.["out-of-scope"],
        };
      }
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    project,
    isLoading: isLoading || locationsLoading,
    isFetching: isFetching || locationsFetching,
    error: error ?? locationsError ?? customError,
  };
};
export default useGetProjectById;
